import { useEffect, useState } from 'react';
import { DashboardLayout } from '@/backoffice/components/layout';
import { Card, getStatusBadge } from '@/backoffice/components/ui';
import { fetchRelayPointPackages } from '@/domains/api/relay-point.api';
import { formatCurrency, formatRelativeTime } from '@/backoffice/utils';
import { Loader2, Package } from 'lucide-react';

export function RelayPointPackagesPage() {
  const [packages, setPackages] = useState<Array<Record<string, unknown>>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRelayPointPackages()
      .then(setPackages)
      .catch(() => setPackages([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <DashboardLayout userType="relay_point" title="Colis">
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-teal-600" /></div>
      ) : packages.length === 0 ? (
        <Card><p className="text-center text-gray-500 py-8">Aucun colis pour ce point relais.</p></Card>
      ) : (
        <div className="space-y-3">
          {packages.map((pkg) => (
            <Card key={String(pkg.id)}>
              <div className="flex items-start justify-between gap-4">
                <div className="flex gap-3">
                  <Package className="w-5 h-5 text-teal-600 mt-1" />
                  <div>
                    <p className="font-mono font-medium">CMD-{String(pkg.id)}</p>
                    <p className="text-sm text-gray-600 mt-1">{String(pkg.departure_address ?? '')}</p>
                    <p className="text-xs text-gray-400">→ {String(pkg.arrival_address ?? '')}</p>
                    <p className="text-xs text-gray-400 mt-1">
                      {pkg.created_at ? formatRelativeTime(String(pkg.created_at)) : ''}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  {getStatusBadge(String(pkg.status ?? 'pending'))}
                  <p className="text-sm font-semibold text-emerald-600 mt-2">
                    {formatCurrency(Number(pkg.total_delivery_fee ?? 0))}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
